import { Ref, ref } from "@vue/composition-api";
import { MassDownloadPolicyL0StatusItem } from "./model";
import * as api from "./api";
import { UseLoading } from "@/common/composition/loading";
import { InfoTypeHelper } from "@/common/models";

const [is_loading, set_loading] = UseLoading(false).as_arr();

const status_list: Ref<MassDownloadPolicyL0StatusItem[]> = ref([]);

const load_status_list = async () => {
  set_loading(true);
  const res = await api.get_mass_download_info_type_status_list();
  if (res.success) {
    status_list.value = res.value.filter(
      (f) => f.id !== InfoTypeHelper.REGULATED_ID()
    );
  }
  set_loading(false);
};

const toggle_item_activity_state = async (item_id: string) => {
  set_loading(true);
  const item = status_list.value.find((f) => f.id === item_id);
  if (item) {
    const res = await api.toggle_l0_mass_download_active_status({
      id: item.id,
      activate: !item.is_active,
      selected_count: item.detect_count,
    });
    if (res.success) {
      status_list.value = status_list.value.map((d) => {
        if (d.id === item_id) {
          return {
            ...d,
            is_active: !d.is_active,
          };
        }
        return d;
      });
    }
  }
  set_loading(false);
};

const update_policy_level = async (item_id: string, level: number) => {
  set_loading(true);
  const item = status_list.value.find((f) => f.id === item_id);
  if (item) {
    const res = await api.toggle_l0_mass_download_active_status({
      id: item.id,
      activate: item.is_active,
      selected_count: level,
    });
    if (res.success) {
      status_list.value = status_list.value.map((d) => {
        if (d.id === item_id) {
          return {
            ...d,
            detect_count: level,
          };
        }
        return d;
      });
    }
  }
  set_loading(false);
};

const init = async () => {
  await load_status_list();
};

export const state = {
  init,
  is_loading,
  status_list,
  toggle_item_activity_state,
  update_policy_level,
};
